var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { EGDSIcon } from '@egds/react-core/icons';
import { EGDSMenu, EGDSMenuContainer, EGDSMenuTrigger } from '@egds/react-core/menu';
import { EGDSTertiaryButton, EGDSButtonSize } from '@egds/react-core/button';
import { EGDSText } from '@egds/react-core/text';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { toMenuItem } from './gc-section-data';
var SHOP_TRAVEL = 'ShopTravel';
var HeaderShopMenu = /** @class */function (_super) {
  __extends(HeaderShopMenu, _super);
  function HeaderShopMenu(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  HeaderShopMenu.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      analytics = _a.analytics,
      menuId = _a.menuId,
      menuLinkText = _a.menuLinkText,
      shopMenuLabel = _a.shopMenuLabel,
      iconSize = _a.iconSize,
      id = _a.id,
      position = _a.position,
      classes = _a.classes,
      menuItems = _a.menuItems,
      showAsExpandable = _a.showAsExpandable;
    var menuIdLowerCase = function () {
      var menuName = menuId.replace('Travel', '');
      menuName = menuName.toLowerCase();
      return menuName;
    };
    var lowerMenuId = menuIdLowerCase();
    var menuTriggerAnalytics = analytics.setupTracker("Header.".concat(menuId), "Expand ".concat(lowerMenuId, " dropdown"));
    var text = menuLinkText ? React.createElement(EGDSText, {
      size: 300
    }, menuLinkText) : null;
    var menuTrigger = React.createElement(EGDSMenuTrigger, null,
    // eslint-disable-next-line no-nested-ternary
    menuId === SHOP_TRAVEL ? text ? React.createElement(EGDSTertiaryButton, {
      size: EGDSButtonSize.MEDIUM,
      className: "global-navigation-nav-button",
      analytics: menuTriggerAnalytics,
      "aria-label": shopMenuLabel
    }, React.createElement(EGDSIcon, {
      name: "search",
      id: "shop-menu-icon",
      title: shopMenuLabel,
      size: iconSize
    }), text) : React.createElement(EGDSTertiaryButton, {
      size: EGDSButtonSize.LARGE,
      className: "global-navigation-nav-button",
      analytics: menuTriggerAnalytics,
      "aria-label": shopMenuLabel
    }, React.createElement(EGDSIcon, {
      name: "search",
      id: "shop-menu-icon",
      title: shopMenuLabel,
      size: iconSize
    })) : React.createElement(EGDSTertiaryButton, {
      className: "global-navigation-nav-button",
      analytics: menuTriggerAnalytics,
      "aria-label": shopMenuLabel
    }, text, React.createElement(EGDSSpacing, {
      padding: {
        blockend: 'half',
        inlinestart: 'half'
      }
    }, React.createElement(EGDSIcon, {
      name: "expand_more",
      size: iconSize
    }))));
    var menuTriggerCaretForced = React.createElement(EGDSMenuTrigger, null, React.createElement(EGDSTertiaryButton, {
      className: "global-navigation-nav-button",
      analytics: menuTriggerAnalytics,
      "aria-label": shopMenuLabel
    }, text, React.createElement(EGDSSpacing, {
      padding: {
        inlinestart: 'half',
        blockend: 'half'
      }
    }, React.createElement(EGDSIcon, {
      name: "expand_more",
      size: iconSize
    }))));
    var isOpen = this.state.isOpen;
    var shopMenuProps = {
      id: id,
      position: position,
      shopMenuLabel: shopMenuLabel,
      menuItems: menuItems,
      isOpen: isOpen,
      onTriggerClick: function () {
        return _this.setState({
          isOpen: !isOpen
        });
      }
    };
    return React.createElement(ShopMenu, __assign({}, shopMenuProps, {
      menuTrigger: showAsExpandable ? menuTriggerCaretForced : menuTrigger
    }));
  };
  return HeaderShopMenu;
}(React.Component);
export { HeaderShopMenu };
export var ShopMenu = function (_a) {
  var id = _a.id,
    position = _a.position,
    shopMenuLabel = _a.shopMenuLabel,
    menuItems = _a.menuItems,
    isOpen = _a.isOpen,
    onTriggerClick = _a.onTriggerClick,
    menuTrigger = _a.menuTrigger;
  return (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 ? React.createElement(EGDSMenu, {
    id: id,
    isOpen: isOpen,
    onTriggerClick: onTriggerClick
  }, menuTrigger, React.createElement(EGDSMenuContainer, {
    position: position,
    width: 375,
    intersectionObserverRoot: "body",
    autoPosition: true
  }, shopMenuLabel && React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'three',
      inline: 'six'
    }
  }, React.createElement(EGDSText, {
    size: 500,
    weight: "bold",
    theme: "default"
  }, shopMenuLabel)), React.createElement("div", {
    className: "uitk-list"
  }, (menuItems || []).map(toMenuItem)))) : null;
};